import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import gettext from '@eb/gettext';
import ngettext from '@eb/ngettext';

import { FollowButton } from '@eb/eds-follow-button';

import { ORGANIZER_ARTICLE_PROPTYPE } from '../../constants/propTypes';

import OrganizerArticleCardBackground from './OrganizerArticleCardBackground';
import OrganizerArticleCardImage from './OrganizerArticleCardImage';
import OrganizerArticleProfileImage from './OrganizerArticleProfileImage';

import './OrganizerArticleCard.scss';

export const getUpcomingEventCopy = (numUpcomingEvents) =>
    ngettext('upcoming event', 'upcoming events', numUpcomingEvents);

export default class OrganizerArticleCard extends React.PureComponent {
    static propTypes = {
        handleFollowOrganizer: PropTypes.func.isRequired,
        trackGAEvent: PropTypes.func.isRequired,
        organizerArticle: ORGANIZER_ARTICLE_PROPTYPE,
        handleViewOrganizer: PropTypes.func,
        handleSetError: PropTypes.func,
        label: PropTypes.string,
        isVisible: PropTypes.bool,
    };

    _handleFollowClick = () => {
        const {
            organizerArticle: { id },
            handleFollowOrganizer,
            trackGAEvent,
        } = this.props;

        trackGAEvent(id);

        handleFollowOrganizer(id);
    };

    _handleOnClick = () => {
        const {
            organizerArticle: {
                // eslint-disable-next-line no-shadow
                id,
            },
            handleViewOrganizer,
            label,
        } = this.props;

        if (handleViewOrganizer) {
            handleViewOrganizer(id, label);
        }
    };

    render() {
        const {
            organizerArticle: {
                // eslint-disable-next-line no-shadow
                profileUrl,
                profileImage,
                articleImage,
                name,
                id,
                summary,
                description,
                subDescription,
                upcoming,
                followedByYou,
            },
            isVisible,
        } = this.props;

        const upcomingClasses = classnames(
            'eds-text-bm',
            'eds-text-color--grey-600',
            'eds-text-weight--heavy',
        );

        let upcommingComponent = null;

        let followButton = (
            <FollowButton
                __containerClassName="organizer-article-card__cta"
                style="standard"
                isFollowing={followedByYou}
                onClick={this._handleFollowClick}
            >
                <span className="eds-is-hidden-accessible">{`${name}.`}</span>
            </FollowButton>
        );

        if (followedByYou) {
            followButton = (
                <div className="organizer-article-card__follow-button">
                    {gettext('Following')}
                </div>
            );
        }

        // Only show Upcoming events if we have more than 0 events to show
        if (upcoming > 0) {
            upcommingComponent = gettext(
                `${upcoming} ${getUpcomingEventCopy(upcoming)}`,
            );
        }

        return (
            <section
                key={id}
                className="organizer-article-card eds-bg-color--background"
            >
                {isVisible && (
                    <>
                        <OrganizerArticleCardBackground image={articleImage} />
                        <OrganizerArticleCardImage
                            image={articleImage}
                            organizerName={name}
                        />
                    </>
                )}

                <div className="organizer-article-card__summary">
                    <div className="organizer-article-card__image_and_text eds-l-pad-bot-4">
                        <a
                            onClick={this._handleOnClick}
                            href={profileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="organizer-article-card__link"
                            title={gettext(`View ${name} profile.`)}
                            tabIndex="-1"
                        >
                            <OrganizerArticleProfileImage
                                image={profileImage}
                            />
                        </a>

                        <a
                            onClick={this._handleOnClick}
                            href={profileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="organizer-article-card__link"
                            title={gettext(`View ${name} profile.`)}
                            tabIndex="-1"
                        >
                            <div className="organizer-article-card__text-container">
                                <div className="organizer-article-card__text eds-l-mar-bot-1">
                                    <h4 className="eds-text-bl eds-text-color--ui-800">
                                        {name}
                                    </h4>
                                </div>
                                <div className={upcomingClasses}>
                                    {upcommingComponent}
                                </div>
                            </div>
                        </a>
                    </div>
                    <div>
                        <div className="organizer-article-card__summary-text eds-text-bm eds-text-weight--heavy eds-text-color--grey-800 eds-l-pad-bot-2">
                            {summary}
                        </div>
                        <div className="eds-text-bm eds-l-sn-pad-bot-6 eds-text-weight--bold">
                            {`Known for ${description}`}
                        </div>
                        <div className="eds-text-bm eds-l-pad-top-2 eds-l-pad-bot-6 eds-text-color--ui-600 eds-hide-sn">
                            {subDescription}
                        </div>
                    </div>
                    {followButton}
                </div>
            </section>
        );
    }
}
